import { render } from "./FacturacionView.vue?vue&type=template&id=01ec5251"
import script from "./FacturacionView.vue?vue&type=script&lang=js"
export * from "./FacturacionView.vue?vue&type=script&lang=js"

import "./FacturacionView.vue?vue&type=style&index=0&id=01ec5251&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__